var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h2',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isBack())?_c('button',{staticClass:"button-back",attrs:{"type":"button"},on:{"click":_vm.back}},[_c('span',{staticClass:"blind"},[_vm._v("뒤로가기 버튼")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d372945","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 